import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { Role } from '@/types/role'

export function updateRole(body: Role): Promise<AxiosResponse<Role>> {
  return instance.put(`/iam/role/${body.uuid}`, body)
}
